import headerSearchToggle from '../modules/_headerSearchToggle';
import headerDrawerToggle from '../modules/_headerDrawerToggle';
import adjustViewport from '../modules/_adjustViewport';
import preventRightClick from '../modules/_preventRightClick';

headerSearchToggle();
headerDrawerToggle();
adjustViewport();
preventRightClick();